<template>
  <!-- Main Content -->
    <div id="search-item-gallery" class="md-layout md-gutter w-100 items-layout" ref="groupPage">
      <div v-if=" !this.wishlistItems" class="no-items-message">
        No items in this user's favorites
      </div>
      <div
        v-for="(item, index) in wishlistItems"
        class="md-layout-item"
        :key="index"
      >
        <SWishlistItem
          :item="item"
          @updateList="updateFavoriteList"
        />
      </div>

    </div>
</template>

<script>
import ChatHelperVue from "../../mixins/ChatHelper.vue";
import SWishlistItem from "@/material-components/organisms/SWishlistItem.vue";
import ItemHelper from '../../mixins/ItemHelper.vue';
import axios from 'axios';
import Global from '../../constants/Global';

const headers = {
  'Content-Type': 'application/json'
};


export default {
  name: "WishlistItems",
  props: ["userProfile"],
  mixins: [ChatHelperVue, ItemHelper],
  components: {
    SWishlistItem,
  },
  data() {
    return {
      selectedKeyChat: {},
      wishlistItems: [],
    };
  },
  computed: {
    wishlistObject(){
      return {
        userId: this.userProfile.id,
      }
    },
  },
  methods: {
    openChat(key) {
      const selectedKeyId = key.id ?? key.group.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
    updateFavoriteList()  {
      this.$emit("updateFavList");
    },
    reloadData(index) {
      this.allActivities.splice(index, 1);
      this.feedKey += 1;
    },
  },
  async mounted() {
    this.wishlistItems = await axios.get(Global.getServerDomain() + '/wishlist', { params: this.userProfile.id }, { headers }).then(response => {return response.data});
    this.showProfile = window.innerWidth > 1024;
    window.addEventListener('resize', this.handleResize);
  },
};
</script>
<style scoped>
.md-layout-item {
  margin: 0 8px 16px !important;
  padding: 0 !important;
  max-width: 575px;
}
.md-layout.md-gutter {
  margin: 0;
}
.items-layout {
  display: flex;
}
.no-items-message {

}
</style>
